import render from './render'

export default {
  name: 'RedirectButton',

  props: {
    service: {
      type: String,
      default: undefined,
      required: true
    }
  },

  methods: {
    redirect() {
      const routeData = this.$router.resolve({
        name: this.service,
        query: { mode: 'create' }
      })
      window.open(window.location.origin + routeData.href, '_blank')
    }
  },

  render
}
